import MyAccountCancelWarningModal from './MyAccountCancelWarningModal'

export default MyAccountCancelWarningModal
// eslint-disable-next-line import/export
export * from './MyAccountCancelWarningModal'
